export default "__VITE_ASSET__3283b129__"